import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/privacy/page";
import TermsOfService from "../pages/terms/page";
import LicenseAgreement from "../pages/license/page";
import HelpCenterPage from "../pages/help/page";
import ShopPage from "../pages/shop/page";
import ChipsShopPage from "../pages/shop/chips";
import CoinsShopPage from "../pages/shop/coins";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shop",
    element: <ShopPage />,
  },
  {
    path: "/shop/chips",
    element: <ChipsShopPage />,
  },
  {
    path: "/shop/coins",
    element: <CoinsShopPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <TermsOfService />,
  },
  {
    path: "/license",
    element: <LicenseAgreement />,
  },
  {
    path: "/help",
    element: <HelpCenterPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;